import React, { useState, useEffect, useContext } from 'react';
import { Outlet } from "react-router-dom";
import '../stylesheets/App.css';
import facebook from '../images/facebook.png';
import {Helmet} from "react-helmet";
import { LanguageContext } from "../Contexts/Languagecontext.js";

const Base = () => {
    const { language, changeLanguage } = useContext(LanguageContext);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 800); // Updated to 800px

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 800); // Updated to 800px
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleLanguageChange = (event) => {
        const newLanguage = event.target.value;
        changeLanguage(newLanguage);
    };

    return (
        <>
            <header className="App-header">
                {isMobileView ? (
                    <div className="Links-mobile">
                        <a href='https://www.facebook.com/ixt.lv/'>
                            <img src={facebook} className='facebook' alt="Facebook" />
                        </a>
                        <div className="line-header">
                            <ion-icon name="call"></ion-icon>
                            <p>+371 26 097 304</p>
                        </div>
                        <div className="line-header">
                            <ion-icon name="mail"></ion-icon>
                            <p>customcars@inbox.lv</p>
                        </div>
                        <div className="line-header">
                            <ion-icon name="location"></ion-icon>
                            <p>Rīga, VEF, Ūnijas 6</p>
                        </div>
                        <select name='lang_id' id='lang' className='select' value={language} onChange={handleLanguageChange}>
                            <option value='ru'>Русский</option>
                            <option value='lv'>Latviešu</option>
                            <option value='en'>English</option>
                        </select>
                    </div>
                ) : (
                    <div className="Links-desk">
                        <a href='https://www.facebook.com/ixt.lv/' className='facebook'>
                            <img src={facebook} className='facebook' alt="Facebook" />
                        </a>
                        <div className="line-header">
                            <ion-icon name="call"></ion-icon>
                            <p>+371 26 097 304</p>
                        </div>
                        <div className="line-header">
                            <ion-icon name="mail"></ion-icon>
                            <p>customcars@inbox.lv</p>
                        </div>
                        <div className="line-header">
                            <ion-icon name="location"></ion-icon>
                            <p>Rīga, VEF, Ūnijas 6</p>
                        </div>
                        <select name='lang_id' id='lang' className='select' value={language} onChange={handleLanguageChange}>
                            <option value='ru'>Русский</option>
                            <option value='lv'>Latviešu</option>
                            <option value='en'>English</option>
                        </select>
                    </div>
                )}
                <Helmet>
                    <script type="module" src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js"></script>
                    <script nomodule src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.js"></script>
                </Helmet>
            </header>
            <Outlet />
        </>
    );
};

export default Base;